import { createSelector } from 'reselect';

import { ApplicationState } from '../../types';

export const selectCoupon = ({ appSumo }: ApplicationState) => appSumo.data?.coupon;
export const selectCouponPending = ({ appSumo }: ApplicationState) => appSumo.isPending;
export const selectRedirectPending = ({ appSumo }: ApplicationState) => appSumo.isRedirectPending;
export const selectCouponError = ({ appSumo }: ApplicationState) => appSumo.error;

export const selectUpgradeState = ({ appSumo }: ApplicationState) => appSumo.upgrade;
export const selectUpgradePending = createSelector(selectUpgradeState, ({ isPending }) => isPending);
export const selectUpgradeError = createSelector(selectUpgradeState, ({ isError, error }) => ({
  isError,
  error
}));

export const selectStatus = ({ appSumo }: ApplicationState) => appSumo.data.status;
